<template>
  <div>
    <v-client-table
      :data='lignesCommandeCommissions'
      :columns="columns"
      :options="options"
      class="displayNoneVuePagination"
      ref="tableListeLigneCommandeCommissions">
      <div slot="libelle" slot-scope="props">
        {{  getLibelleRegroupement(props.row.referenceRegroupement) + ' - ' + props.row.libelle }}
      </div>
      <div slot="prixUnitaire" slot-scope="props">
        {{  props.row.prixUnitaire | formatDevise }}
      </div>
      <div slot="quantite" slot-scope="props">
        {{  (props.row.quantite * 100).toFixed(2) | formatPercent }}
      </div>
      <div slot="remise" slot-scope="props">
        {{  100 - Math.abs(props.row.remise) | formatPercent}}
      </div>
      <div slot="pourcentageTva" slot-scope="props">
        {{ props.row.tauxTva | formatPercent }}
      </div>
      <div slot="montantTva" slot-scope="props">
        {{ ((props.row.totalHtAvecLigneRemise * (1 + (props.row.tauxTva / 100)))
      - props.row.totalHtAvecLigneRemise).toFixed(2)  }} €
      </div>
      <div slot="totalHt" slot-scope="props">
        {{ props.row.totalHtAvecLigneRemise | formatDevise}}
      </div>
    </v-client-table>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import {
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { REGROUPEMENT } from '@/configuration/devisConf';
import { columnsSplice } from '@/services/general/columns';

export default {
  name: 'recapitulatifCommissionsLignesCommande',
  props: {
    lignesCommande: {
      type: Array,
      required: true,
    },
    lignesCommandeCommissions: {
      type: Array,
      required: true,
    },
    visualisationTva: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    options() {
      const texts = cloneDeep(TEXTS);
      texts.count = '';
      return {
        sortIcon: SORT_ICON,
        headings: {
          libelle: this.$i18n.t('listeCommandeCommissions.ligneCommande.libelle'),
          prixUnitaire: this.$i18n.t('listeCommandeCommissions.ligneCommande.prixUnitaire'),
          quantite: this.$i18n.t('listeCommandeCommissions.ligneCommande.quantite'),
          remise: this.$i18n.t('listeCommandeCommissions.ligneCommande.remise'),
          totalHt: this.$i18n.t('listeCommandeCommissions.ligneCommande.totalHt'),
          pourcentageTva: this.$i18n.t('listeCommandeCommissions.ligneCommande.pourcentageTva'),
          montantTva: this.$i18n.t('listeCommandeCommissions.ligneCommande.montantTva'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: texts,
        columnsClasses: {
          delete: 'colonneSelected',
        },
        sortable: ['libelle', 'prixUnitaire', 'remise', 'totalHt'],
      };
    },
    columns() {
      const columns = ['libelle', 'quantite', 'prixUnitaire', 'totalHt', 'pourcentageTva', 'montantTva', 'remise'];
      if (!this.visualisationTva) {
        columnsSplice(columns, 'pourcentageTva');
        columnsSplice(columns, 'montantTva');
      }
      return columns;
    },
  },
  methods: {
    getLibelleRegroupement(reference) {
      return this.lignesCommande.find((ligne) => ligne.type === REGROUPEMENT
        && ligne.referenceRegroupement === reference).libelle;
    },
  },
};
</script>

<style scoped>

</style>
